'use strict';
import * as $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dRange$0024 from "./app.data.types_drug$package$-Drug-Request-Range$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserSettings$$anon$8() {
}
export { $c_Lapp_data_GeneralPracticeUserSettings$$anon$8 as $c_Lapp_data_GeneralPracticeUserSettings$$anon$8 };
$c_Lapp_data_GeneralPracticeUserSettings$$anon$8.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserSettings$$anon$8.prototype.constructor = $c_Lapp_data_GeneralPracticeUserSettings$$anon$8;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserSettings$$anon$8() {
}
export { $h_Lapp_data_GeneralPracticeUserSettings$$anon$8 as $h_Lapp_data_GeneralPracticeUserSettings$$anon$8 };
$h_Lapp_data_GeneralPracticeUserSettings$$anon$8.prototype = $c_Lapp_data_GeneralPracticeUserSettings$$anon$8.prototype;
$c_Lapp_data_GeneralPracticeUserSettings$$anon$8.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_GeneralPracticeUserSettings$$anon$8.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy4 = $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dRange$0024.$m_Lapp_data_types\uff3fdrug$package$DrugRequestRange$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy4, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForInt);
});
$c_Lapp_data_GeneralPracticeUserSettings$$anon$8.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_data_GeneralPracticeUserSettings$$anon$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserSettings$$anon$8, "app.data.GeneralPracticeUserSettings$$anon$8", ({
  Lapp_data_GeneralPracticeUserSettings$$anon$8: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_GeneralPracticeUserSettings$$anon$8 as $d_Lapp_data_GeneralPracticeUserSettings$$anon$8 };
//# sourceMappingURL=app.data.-General-Practice-User-Settings$$anon$8.js.map
